'use client';
import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Logo } from '../../Logo';
import styles from './BaseModal.module.css';

interface BaseModalProps {
	isOpen: boolean;
	onClose: () => void;
	title: string;
	subtitle?: string;
	children: React.ReactNode;
	actions?: React.ReactNode;
	isLoading?: boolean;
	wide?: boolean;
	maxWidth?: string;
	maxHeight?: string;
}

export const BaseModal = ({
	isOpen,
	onClose,
	title,
	subtitle,
	children,
	actions,
	isLoading,
	wide,
	maxWidth,
	maxHeight,
}: BaseModalProps) => {
	if (!isOpen) return null;

	const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
		if (e.target === e.currentTarget) {
			onClose();
		}
	};

	return (
		<div className={styles.overlay} onClick={handleOverlayClick} role="presentation">
			<div
				className={`${styles.modal} ${wide ? styles.modalWide : ''}`}
				style={maxWidth || maxHeight ? { maxWidth, maxHeight } : undefined}
				role="dialog"
				aria-modal="true"
				aria-labelledby="modal-title"
			>
				<div className={styles.header}>
					<div className={styles.headerTop}>
						<Logo className={styles.logo} />
						<button
							className={styles.closeButton}
							onClick={onClose}
							disabled={isLoading}
							aria-label="Fechar modal"
							type="button"
						>
							<CloseIcon className={styles.closeIcon} />
						</button>
					</div>
					<div className={styles.titleGroup}>
						<h2 id="modal-title" className={styles.title}>
							{title}
						</h2>
						{subtitle && <p className={styles.subtitle}>{subtitle}</p>}
					</div>
				</div>

				<div className={styles.content}>{children}</div>

				{actions && <div className={styles.actions}>{actions}</div>}
			</div>
		</div>
	);
};
